import { render, staticRenderFns } from "./Companies.vue?vue&type=template&id=a25a9cb6&scoped=true"
import script from "./Companies.vue?vue&type=script&lang=js"
export * from "./Companies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25a9cb6",
  null
  
)

export default component.exports